import type { OrganizationSettings } from '@lib/types/organizationSettings.types'
import type { InstanceSettings } from '@lib/types/instanceSettings.types'
import type { FileRetrieve } from '@openapi'

export const shouldOpenInCollectionPlayerViewer = (
  pitcherSettings: OrganizationSettings & InstanceSettings,
  file?: FileRetrieve,
) => {
  const defaultCollectionPlayer = pitcherSettings.use_collection_player_as_default_file_viewer

  if (defaultCollectionPlayer || !file) {
    return defaultCollectionPlayer
  }

  const forceCollectionPlayer = file.metadata?.usecollectionplayer
  const originalExtension = pitcherSettings.use_collection_player_as_default_file_viewer_for_original_extensions ?? []
  const contentExtensions = pitcherSettings.use_collection_player_as_default_file_viewer_for_content_extensions ?? []

  return (
    forceCollectionPlayer ||
    (file.original_extension && originalExtension.includes(file.original_extension)) ||
    (file.content_extension && contentExtensions.includes(file.content_extension))
  )
}
